import { complianceMerchantEnvironment } from './constants'

export const serializeMetrcEmployeeConfigRequest = (userApiKey, enabled) => {
  const request = {
    data: {
      type: 'compliance_employees',
      attributes: {
        credentials: [
          {
            complianceType: 'METRC',
            clientSecret: userApiKey ?? undefined,
            enabled: enabled ?? undefined,
          },
        ],
      },
    },
  }
  return request
}

export const serializeMetrcConfigRequest = (facility) => {
  const { environment, facLicense, userApiKey, stateCode } = facility
  const request = {
    data: {
      type: 'compliance_merchants',
      attributes: {
        stateOrProvince: stateCode,
        credentials: [
          {
            complianceType: 'METRC',
            clientId: facLicense ?? undefined,
            clientSecret: userApiKey ?? undefined,
            environment: complianceMerchantEnvironment(environment),
          },
        ],
      },
    },
  }

  return request
}

export const serializeBiotrackConfigRequest = (location) => {
  const {
    stateCode,
    environment,
    userName,
    password,
    licenseUBI,
    locationLicense,
    enabled,
    deliveryEnabled,
  } = location
  const request = {
    data: {
      type: 'compliance_merchants',
      attributes: {
        stateOrProvince: stateCode,
        credentials: [
          {
            complianceType: 'BIOTRACK',
            clientId: userName ?? undefined,
            clientSecret: password ?? undefined,
            extraClientId: licenseUBI ?? undefined,
            externalId: locationLicense ?? undefined,
            enabled: enabled ?? undefined,
            deliveryEnabled: deliveryEnabled ?? undefined,
            environment: complianceMerchantEnvironment(environment),
          },
        ],
      },
    },
  }

  return request
}



// WEBPACK FOOTER //
// ./src/utils/complianceServiceDataBuilders.js